$(() => {
    $('[data-select-content]').click(function (ev) {
        const selectedContentEl = $(this);
        const variationCode = selectedContentEl.attr('data-select-content').toUpperCase();

        if (variationCode && window.productFields && window.dataLayer) {
            const productField = window.productFields.find((x) => x.id === variationCode);
            var cmpData = window.__cmp('getCMPData');

            if (productField && cmpData && cmpData.vendorConsents['s905'] === true) {
                ev.preventDefault();
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    event: 'productClick',
                    ecommerce: {
                        click: {
                            products: [
                                {
                                    name: productField.name,
                                    id: productField.id,
                                    price: productField.price,
                                    category: productField.category,
                                    variant: productField.variant
                                }
                            ]
                        }
                    },
                    eventCallback: function () {
                        window.location.href = selectedContentEl.attr('href');
                    }
                });
            }
        }
    });
});
